import { render, staticRenderFns } from "./description-section.vue?vue&type=template&id=aad6a288"
import script from "./description-section.vue?vue&type=script&lang=js"
export * from "./description-section.vue?vue&type=script&lang=js"
import style0 from "./description-section.vue?vue&type=style&index=0&id=aad6a288&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports